module.exports = __webpack_public_path__ + "images/b2591afc2b40620d72a17015aa68b557.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Shell/scenes/Header/img/tumc-logo.jpg
// module id = 568
// module chunks = 0